import { zeroPad } from "./zeroPad";

export function formatApiDate(date: Date) {
  return `${date.getFullYear()}-${zeroPad(date.getMonth() + 1)}-${zeroPad(date.getDate())}`;
}
